(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-cart-recommendations]');
    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const url = section.dataset.recommendationsUrl;
      const track = section.querySelector('[data-recommendation-track]');
      const viewport = section.querySelector('[data-recommendation-viewport]');
      const controls = section.querySelector('[data-recommendation-controls]');
      const previous = section.querySelector('[data-recommendation-prev]');
      const next = section.querySelector('[data-recommendation-next]');

      if (!url || !track || !viewport) return;

      const updateControls = () => {
        if (!controls) return;
        const canScroll = track.scrollWidth > viewport.clientWidth + 8;
        controls.hidden = !canScroll;
      };

      const loadRecommendations = async () => {
        try {
          const response = await fetch(url);
          if (!response.ok) return;
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const rendered = parsed.querySelector('[data-cart-recommendations]');
          if (!rendered) return;
          const renderedTrack = rendered.querySelector('[data-recommendation-track]');
          if (!renderedTrack || !renderedTrack.children.length) {
            section.hidden = true;
            return;
          }
          track.innerHTML = renderedTrack.innerHTML;
          updateControls();
        } catch (error) {
          section.hidden = true;
        }
      };

      previous?.addEventListener('click', () => {
        viewport.scrollBy({ left: -Math.max(viewport.clientWidth * 0.85, 280), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        viewport.scrollBy({ left: Math.max(viewport.clientWidth * 0.85, 280), behavior: 'smooth' });
      });

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 240px 0px' });

      observer.observe(section);
      window.addEventListener('resize', updateControls, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
